
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Completed hybrid code examples for `}<a parentName="p" {...{
        "href": "/patterns/lists"
      }}>{`Lists`}</a>{` and `}<a parentName="p" {...{
        "href": "/patterns/appbar"
      }}>{`App Bars`}</a>{`. Added `}<a parentName="p" {...{
        "href": "https://github.com/pxblue/react-component-library/blob/dev/docs/InfoListItem.md"
      }}>{`InfoListItem`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/pxblue/react-component-library/blob/dev/docs/ScoreCard.md"
      }}>{`ScoreCard`}</a>{` components to the React component library. Added `}<a parentName="p" {...{
        "href": "https://github.com/pxblue/react-native-component-library/blob/dev/docs/Header.md"
      }}>{`Header`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/pxblue/react-native-component-library/blob/dev/docs/InfoListItem.md"
      }}>{`InfoListItem`}</a>{`, and `}<a parentName="p" {...{
        "href": "https://github.com/pxblue/react-native-component-library/blob/dev/docs/ScoreCard.md"
      }}>{`ScoreCard`}</a>{` components to the React Native component library.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;